import React from 'react';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../../MetricLoader';
import moment from 'moment-timezone';
import ComparisonMetric from '../../ComparisonMetric';
import useEducatorEvaluationsCompleted from './useEducatorEvaluationsCompleted';
import useEducatorEvaluationsCreated from './useEducatorEvaluationsCreated';

export default function PercentEducatorEvaluationsCompleted(props) {
  const { network, schoolStart, schoolEnd, titleOnly = false } = props;

  const title = `% of educator evaluations completed`;

  const previousSchoolStart = moment(schoolStart).subtract(1, 'year').toISOString();

  const previousCompleted = useEducatorEvaluationsCompleted(network, {
    start: titleOnly ? undefined : previousSchoolStart,
    end: schoolStart
  });

  const newCompleted = useEducatorEvaluationsCompleted(network, {
    start: schoolStart,
    end: schoolEnd
  });

  const previousCreated = useEducatorEvaluationsCreated(network, {
    start: titleOnly ? undefined : previousSchoolStart,
    end: schoolStart
  });

  const newCreated = useEducatorEvaluationsCreated(network, {
    start: schoolStart,
    end: schoolEnd
  });

  if (
    previousCreated.state === PayloadStates.FETCHING ||
    newCreated.state === PayloadStates.FETCHING ||
    previousCompleted.state === PayloadStates.FETCHING ||
    newCompleted.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name={title}
      />
    );
  }

  const newPercent = Math.ceil(newCompleted.meta.totalCount / newCreated.meta.totalCount * 100);
  const previousPercent = Math.ceil(previousCompleted.meta.totalCount / previousCreated.meta.totalCount * 100);

  return (
    <ComparisonMetric
      name={title}
      value={newPercent}
      previousValue={previousPercent}
      titleOnly={titleOnly}
      percent={true}
    />
  );
}
